import { Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';

import { AppMenuComponent } from './app.menu.component';
import { LayoutService } from './service/app.layout.service';
import { VersionTagComponent } from './version-tag/version-tag.component';

@Component({
  selector: 'app-sidebar',
  templateUrl: './app.sidebar.component.html',
  styleUrl: './app.sidebar.component.scss',
  imports: [AppMenuComponent, VersionTagComponent]
})
export class AppSidebarComponent implements OnDestroy {
  timeout: any = null;

  @ViewChild('menuContainer') menuContainer!: ElementRef;

  constructor(
    public layoutService: LayoutService,
    public el: ElementRef
  ) {}

  resetOverlay() {
    if (this.layoutService.state.overlayMenuActive) {
      this.layoutService.state.overlayMenuActive = false;
    }
  }

  // get menuProfilePosition(): string {
  //     return this.layoutService.config().menuProfilePosition;
  // }

  onMouseEnter() {
    if (!this.layoutService.state.anchored) {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.layoutService.state.sidebarActive = true;
    }
  }

  onMouseLeave() {
    if (!this.layoutService.state.anchored) {
      if (!this.timeout) {
        this.timeout = setTimeout(() => (this.layoutService.state.sidebarActive = false), 300);
      }
    }
  }

  anchor() {
    this.layoutService.state.anchored = !this.layoutService.state.anchored;
  }

  ngOnDestroy() {
    this.resetOverlay();
  }
}
